import { render, staticRenderFns } from "./region-list-item-result.vue?vue&type=template&id=3684ec6c&"
import script from "./region-list-item-result.vue?vue&type=script&lang=js&"
export * from "./region-list-item-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports